import { NavLink } from "react-router-dom";
import { LayoutDashboard, Target, Building2, CheckSquare, Menu } from "lucide-react";
import { Sheet, SheetContent, SheetTrigger, SheetTitle } from "@/components/ui/sheet";
import { Users, MapPin, FileText, FolderKanban, BarChart3, Settings, Lock, Package2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const PRIMARY = [
  { to: "/dashboard", label: "Home", icon: LayoutDashboard },
  { to: "/leads", label: "Leads", icon: Target },
  { to: "/companies", label: "Firms", icon: Building2 },
  { to: "/tasks", label: "Tasks", icon: CheckSquare },
];

const ALL = [
  { to: "/dashboard", label: "Dashboard", icon: LayoutDashboard },
  { to: "/leads", label: "Leads", icon: Target },
  { to: "/companies", label: "Companies", icon: Building2 },
  { to: "/contacts", label: "Contacts", icon: Users, hideForAccounts: true },
  { to: "/tasks", label: "Tasks", icon: CheckSquare, hideForAccounts: true },
  { to: "/settings", label: "Settings", icon: Settings, adminOnly: true },
  { to: "/site-visits", label: "Site Visits", icon: MapPin, soon: true, hideForAccounts: true },
  { to: "/quotations", label: "Quotations", icon: FileText },
  { to: "/projects", label: "Projects", icon: FolderKanban },
  { to: "/stock", label: "Stock", icon: Package2 },
  { to: "/reports", label: "Reports", icon: BarChart3, soon: true },
];

export function MobileMenu() {
  const { user } = useAuth();
  const canSettings = ["ADMIN", "SALES_MANAGER"].includes(user?.role);
  const isAccounts = user?.role === "ACCOUNTS";
  const items = ALL.filter((i) => {
    if (i.adminOnly && !canSettings) return false;
    if (i.hideForAccounts && isAccounts) return false;
    return true;
  });
  return (
    <Sheet>
      <SheetTrigger asChild>
        <button data-testid="mobile-menu-trigger" className="md:hidden flex h-9 w-9 items-center justify-center rounded-lg border border-slate-200 text-slate-600">
          <Menu className="h-5 w-5" />
        </button>
      </SheetTrigger>
      <SheetContent side="left" className="w-72 p-0 border-0" style={{ backgroundColor: "#0C1929" }}>
        <SheetTitle className="sr-only">Menu</SheetTitle>
        <div className="flex items-center px-5 h-16 border-b border-white/5">
          <img src="/dazlac-logo.png" alt="Dazlac" className="h-8 w-auto" data-testid="mobile-nav-logo" />
        </div>
        <nav className="p-3 space-y-0.5">
          {items.map((item) => {
            const Icon = item.icon;
            if (item.soon) return (
              <div key={item.to} className="flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm text-slate-500">
                <Icon className="h-[18px] w-[18px] opacity-60" /><span className="flex-1">{item.label}</span><Lock className="h-3 w-3" />
              </div>
            );
            return (
              <NavLink key={item.to} to={item.to}
                className={({ isActive }) => `flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm font-medium ${isActive ? "text-white" : "text-slate-300"}`}
                style={({ isActive }) => (isActive ? { backgroundColor: "#0057A8" } : {})}>
                <Icon className="h-[18px] w-[18px]" /><span>{item.label}</span>
              </NavLink>
            );
          })}
        </nav>
      </SheetContent>
    </Sheet>
  );
}

export function BottomNav() {
  const { user } = useAuth();
  const isAccounts = user?.role === "ACCOUNTS";
  const items = PRIMARY.filter((i) => !i.hideForAccounts || !isAccounts);
  return (
    <nav className="md:hidden fixed bottom-0 inset-x-0 z-40 flex items-center justify-around border-t border-slate-200 bg-white/95 backdrop-blur px-2 pb-[env(safe-area-inset-bottom)]">
      {items.map((item) => {
        const Icon = item.icon;
        return (
          <NavLink key={item.to} to={item.to} data-testid={`bottomnav-${item.label.toLowerCase()}`}
            className={({ isActive }) => `flex flex-1 flex-col items-center gap-0.5 py-2.5 text-[10px] font-semibold ${isActive ? "" : "text-slate-400"}`}
            style={({ isActive }) => (isActive ? { color: "#0057A8" } : {})}>
            <Icon className="h-5 w-5" />
            {item.label}
          </NavLink>
        );
      })}
    </nav>
  );
}
